import { constants } from './dropdown.constant'

import { createSelector } from '@/factory'

const getHandlers = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.handler }, true)
const getContent = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.content }, true)

export const dropDownSelectors = {
	getHandlers,
	getContent,
}
